export default "__VITE_ASSET__DXjRgu2f__"